import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";

import JsonlViewer from "./JsonlViewer";
import { JsonlFetchPage } from "./jsonlUtils";

interface JsonlViewerModalProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  fetchPage: JsonlFetchPage;
}

const JsonlViewerModal: React.FC<JsonlViewerModalProps> = ({
  visible,
  onClose,
  title,
  fetchPage,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onClose}
      width={1200}
      footer={[
        <Button key="close" onClick={onClose}>
          {t("Common-Close")}
        </Button>,
      ]}
      destroyOnClose
    >
      {visible ? <JsonlViewer fetchPage={fetchPage} /> : null}
    </Modal>
  );
};

export default JsonlViewerModal;
